import { getDecrypted } from '@/utils/functions/helperFunctions';

export function getToken() {
    const token = localStorage.getItem('token');
    let decryptedToken;
    if (token && token !== 'undefined') {
        try {
            decryptedToken = getDecrypted(JSON.parse(token));
        } catch (e) {
            //Leaving this console here so that we can identify the auto-logout
            console.log(e);
            localStorage.clear();
        }
    }

    return decryptedToken;
}

export function getName() {
    const name = getDecrypted(localStorage.getItem('name'));
    return name ? name : '';
}

export function getemail_address() {
    const email = getDecrypted(localStorage.getItem('email_address'));
    return email ? email : '';
}

export function getUserId() {
    return getDecrypted(localStorage.getItem('userId'));
}
